import React from "react";
import { Link } from "react-router-dom";
import { parseFecha, diasHasta } from "./fechas";

// Franja de avisos accionables del dashboard. El saldo pendiente y las
// facturas se muestran en "Estado de tus servicios"; aquí solo queda el aviso
// de préstamo por renovar. Si no hay nada, muestra un estado positivo.

const arr = (x) => (Array.isArray(x) ? x : []);

const DashAvisos = ({ prestamos }) => {
    const avisos = [];

    // Préstamo por renovar (vence en 5 días o menos, o ya vencido)
    const porVencer = arr(prestamos).filter((p) => {
        const d = parseFecha(p.datedev);
        return d && diasHasta(d) <= 5;
    });

    if (porVencer.length > 0) {
        avisos.push({
            tono: "warning",
            icon: "fa-clock-o",
            texto:
                porVencer.length === 1
                    ? `Tienes 1 libro por devolver o renovar pronto.`
                    : `Tienes ${porVencer.length} libros por devolver o renovar pronto.`,
            ctaTexto: "Ver préstamos",
            ctaIcon: "fa-book",
            to: "/prestamos",
        });
    }

    if (avisos.length === 0) {
        return (
            <div className="esen-alert-strip">
                <div className="esen-alert esen-alert--success">
                    <span className="esen-alert-icon">
                        <i className="fa fa-check-circle" aria-hidden="true"></i>
                    </span>
                    <span className="esen-alert-text">
                        Estás al día. No tienes préstamos por vencer.
                    </span>
                </div>
            </div>
        );
    }

    return (
        <div className="esen-alert-strip">
            {avisos.map((a, i) => (
                <div key={i} className={`esen-alert esen-alert--${a.tono}`}>
                    <span className="esen-alert-icon">
                        <i className={`fa ${a.icon}`} aria-hidden="true"></i>
                    </span>
                    <span className="esen-alert-text">{a.texto}</span>
                    <Link
                        to={a.to}
                        className="btn btn-sm btn-primary esen-alert-cta"
                        onClick={a.onClick}
                    >
                        <i className={`fa ${a.ctaIcon} mr-1`} aria-hidden="true"></i>
                        {a.ctaTexto}
                    </Link>
                </div>
            ))}
        </div>
    );
};

export default DashAvisos;
